var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 18.75H6M29 18.75C29 18.75 26.125 24.5 21.8125 24.5C17.5 24.5 17.5 24.5 13.1875 24.5C8.875 24.5 6 18.75 6 18.75M29 18.75H33.3125M6 18.75H1.6875",
    stroke: "#81BC45",
    strokeWidth: 2.5875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2805 18.75C26.4713 14.6062 22.2183 11.7062 17.4999 11.7062C12.7815 11.7062 8.52844 14.6062 7.71924 18.75H10.3962C11.1781 16.3032 13.9059 14.2937 17.4999 14.2937C21.0939 14.2937 23.8217 16.3032 24.6036 18.75H27.2805Z",
    fill: "#81BC45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.6875V4.375",
    stroke: "#81BC45",
    strokeWidth: 2.5875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.6875V4.375",
    stroke: "#81BC45",
    strokeWidth: 2.5875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.8125V1.5",
    stroke: "#81BC45",
    strokeWidth: 2.5875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipes);
export default __webpack_public_path__ + "static/media/recipes.9c897c7949f01cc8d0c7727bba52d650.svg";
export { ForwardRef as ReactComponent };